import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel } from '../../../../../../core/_base/crud';
import { RdBoM } from '../cong-thuc-dinh-muc-model/cong-thuc-dinh-muc.model';
const API_ROOT_URL = environment.ApiRoot + '/kdyeucauduyetgia';

const ROOT_URL = environment.ApiRoot + '/congthucdinhmuc';

@Injectable()
export class CongThucDinhMucService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDN$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	getData(queryParams: QueryParamsModel): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<RdBoM>(ROOT_URL + '/BOM_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}
	GetListThanhPham(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(ROOT_URL+`/GetListThanhPham`, { headers: httpHeaders});
	}
	GetSoGiaiDoan(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(ROOT_URL+`/GetSoGiaiDoan`, { headers: httpHeaders});
	}
	GetListQTSX(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(ROOT_URL+`/GetListQTSX`, { headers: httpHeaders});
	}
	insert(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(ROOT_URL+'/BOM_Insert', item, { headers: httpHeaders });
	}
	edit(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/BOM_Update', item, { headers: httpHeaders });
	}
	detail(Id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams()
		.set("Id", Id.toString());
		return this.http.get<RdBoM>(ROOT_URL+`/BOM_Detail`, { headers: httpHeaders, params: params });
	}
	delete(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<RdBoM>(ROOT_URL+`/BOM_Delete`, { headers: httpHeaders, params: params });
	}

	cancel(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<RdBoM>(ROOT_URL+`/BOM_Cancel`, { headers: httpHeaders, params: params });
	}
	accept(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/BOM_accept', item, { headers: httpHeaders });
	}
	confirm(item: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/BOM_confirm', item, { headers: httpHeaders });
	}
	
	getListKhuVucWithListBTP(list: any): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(ROOT_URL+'/KVSX_WITH_BTP_LIST', list, { headers: httpHeaders });
	}

	getListAllThietBiWithIdTP(item: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const params = new HttpParams().set("Id", item.toString());
		return this.http.get<RdBoM>(ROOT_URL+`/List_AllThietBi_WithIdTP`, { headers: httpHeaders, params: params });
	}
}
